import { environment } from 'src/environments/environment';

export class API {
  public static readonly AUTH = `${environment.user_management_service_url}/secured`;
  public static readonly LOGIN = `${API.AUTH}/login`;
  public static readonly ROLES = `${API.AUTH}/roles`;

  public static readonly STORAGE = environment.storage_server_service_url;
  public static readonly DATASHEET = environment.datasheet_storage_server_url;
  public static readonly DOCUMENTS_STORAGE = environment.anflexWeb
    ? `${API.STORAGE}/simulations`
    : `${API.STORAGE}/datasheets`;
  public static readonly DOCUMENTS_STORAGE_METADATA = 'update_metadata';
  public static readonly DOCUMENTS_FILTER_STORAGE = `${API.DOCUMENTS_STORAGE}/filter`;
  public static readonly DOCUMENTS_FILTERS_OPTIONS = `${API.DOCUMENTS_STORAGE}/filtering_values`;
  public static readonly DOCUMENTS_LIST = `${API.DOCUMENTS_STORAGE}/all`;
  public static readonly DOCUMENTS_VERSIONED = `${API.DOCUMENTS_STORAGE}/versioned`;
  public static readonly RISER_DATASHEET_STORAGE = `${API.DATASHEET}/datasheets`;
  public static readonly RISER_DATASHEET_FILTER_STORAGE = `${API.RISER_DATASHEET_STORAGE}/filter`;
  public static readonly DOCUMENTS_COPY = `copy`;
  public static readonly CREATE_REVISION = `new_revision`;

  public static readonly DUCT_INFO = `${API.STORAGE}/duct_info`;

  public static readonly USERS = `${API.STORAGE}/users`;
  public static readonly USER_UPSERT = `${API.USERS}/upsert`;

  public static readonly CATENARY = environment.catenary_generation_service_url;
  public static readonly CATENARY_GENERATION = `${API.CATENARY}/catenary`;
  public static readonly CATENARY_3D = `${API.CATENARY}/catenary3D`;

  public static readonly MODEL_VALIDATOR = `${API.CATENARY}/validator`;
  public static readonly SIMULATION_ERRORS_LOG = `${API.MODEL_VALIDATOR}/simulation_status`;
  public static readonly POST_PROCESS_ERRORS_LOG = `${API.MODEL_VALIDATOR}/post-processing`;

  public static readonly SIMSUB_OPTIONS = `${API.CATENARY}/simsub-analysis-options`;
  public static readonly SIMULATION_RESULT_DOWNLOAD = `${API.CATENARY}/download`;
  public static readonly RUN_SIMULATION = `${API.CATENARY}/anflexweb_run_simulation`;
  public static readonly SIMULATION_RUNS = `${API.CATENARY}/anflexweb_runs`;
  public static readonly SIMULATION_RUN = `${API.CATENARY}/anflexweb_run`;

  public static readonly SIMULATION_RUN_FATIGUE_FLEX = `${API.CATENARY}/anflexweb_run_fadflex_analysis`;
  public static readonly SIMULATION_GET_FATIGUE_FLEX = `${API.CATENARY}/anflexweb_get_fadflex_result`;
  public static readonly SIMULATION_RUN_FATIGUE_STEEL = `${API.CATENARY}/anflexweb_run_steelpipe_analysis`;
  public static readonly SIMULATION_GET_FATIGUE_STEEL = `${API.CATENARY}/anflexweb_get_steelpipe_result`;

  public static readonly PROCESSING = `${API.CATENARY}/processing`;
  public static readonly PROCESSING_RUN_ENVELOPE = `/run-envelopes-post-processing`;
  public static readonly PROCESSING_GET_ENVELOPE = `/envelopes-post-processing-results`;
  public static readonly PROCESSING_ENVELOPE_ROUTE = `/envelopes`;
  public static readonly PROCESSING_ENVELOPE = `${API.PROCESSING}${API.PROCESSING_ENVELOPE_ROUTE}`;
  public static readonly PROCESSING_RAW_ENVELOPE_RESULTS = `${API.PROCESSING_ENVELOPE_ROUTE}/results`;
  public static readonly PROCESSING_RAW_ENVELOPE_PARAMS = `${API.PROCESSING_ENVELOPE_ROUTE}/results-variables`;

  public static readonly SIMULATION_REPORT_FATIGUE = `${API.CATENARY}/simulations/postprocessing/report/fatigue`;
  public static readonly SIMULATION_GENERATE_REPORT_FATIGUE_FLEX = `${API.SIMULATION_REPORT_FATIGUE}/fadflex`;
  public static readonly SIMULATION_GENERATE_REPORT_FATIGUE_STEEL = `${API.SIMULATION_REPORT_FATIGUE}/steelpipe`;

  public static readonly AML_LOADER = environment.aml_loader_service_url;
  public static readonly AML_CONVERT_TO_JSON = `${API.AML_LOADER}/convert_to_json`;
  public static readonly AML_CONVERT_TO_AML = `${API.AML_LOADER}/convert_to_aml`;

  public static readonly MESH = `${API.CATENARY}/mesh`;

  public static readonly RESULTS = `${API.CATENARY}/results`;
  public static readonly VARIABLES = `${API.RESULTS}/result-variables`;

  public static readonly FINITE_ELEMENTS = `${API.MESH}/finite-element`;
  public static readonly SUMMARY = `${API.CATENARY}/simulations/lines/summary`;
}
